import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { IGroupEvent } from '../Types';

const RESOURCE = 'events';

interface IUpdateGroupEvent extends Omit<IUri, 'resource'> {
  id: string;
  body: Partial<IGroupEvent>;
  token: string;
}

interface IUpdateGroupEventsResponse extends IHttpResponse {
  body?: IGroupEvent;
}

export default ({
  id,
  body,
  token,
}: IUpdateGroupEvent): Promise<IUpdateGroupEventsResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
    id,
  });

  return BaseService.Patch({ url, token, data: body });
};
